// Amazon FBM orders routed to a store (2026-10-14, Eric): the Move action tags the order
// `FBM-Routed`. In the Orders list such a row reads "Amazon FBM" in the Source column and
// shimmers green while it still has to be shipped (not cancelled, not archived, unfulfilled
// at this location), like the pulsing blue retail-store rows.
export function isFbmRouted(o) {
    const tags = (o && o.tags) || [];
    return Array.isArray(tags) && tags.some(t => String(t).toLowerCase() === 'fbm-routed');
}

// Any order that came in from Amazon (Marketplace Connect tags it Amazon / Amazon-US / FBM) is an
// "Amazon FBM" order in the Source column (Eric, 2026-10-16), routed to a store yet or not.
export function isAmazonFbm(o) {
    const tags = (o && o.tags) || [];
    return Array.isArray(tags) && tags.some(t => { const s = String(t).toLowerCase(); return s === 'amazon' || s === 'fbm-routed'; });
}

export function isFbmOpenRow(fo) {
    const o = (fo && fo.order) || {};
    if (!isFbmRouted(o)) return false;
    if (o.cancelled_at || o.closed_at) return false;
    const st = String(fo.row_fulfillment_status || o.fulfillment_status || 'UNFULFILLED').toUpperCase();
    return st === 'UNFULFILLED' || st === 'PARTIALLY_FULFILLED';
}
